import type { SEORecursiveMapping } from '@/constants/page.constants';

export const cmsQueryKeys = {
  getPrimaryNavigation: ['getPrimaryNavigation'],
  getBaselineNavigation: ['getBaselineNavigation'],
  getFooterNavigation: ['getFooterNavigation'],
  getCMSPageContent: ['getCMSPageContent'],
  getTabs: ['getTabs'],
  getBlogContent: ['getBlogContent'],
  getBlogDetailedContent: ['getBlogDetailedContent'],
  getBlogFilter: ['getBlogFilter'],
  getBlogContentById: ['getBlogContentById'],
  getBlogRelatedArticles: ['getBlogRelatedArticles'],
  getPartialBySlug: ['getPartialBySlug'],
  getGlobals: ['getGlobals'],
  getCMSChatBotType: ['chatBot'],
  getCMSForm: (handle: string) => ['getCMSForm', handle] as const,
  getSEOContent: (seoMapping: SEORecursiveMapping) => [
    'getSEOContent',
    seoMapping,
  ],
};
